import { useEffect, useState } from "react";
import { authFetch } from "../../App";
import { BookOpen } from "lucide-react";

const API = "/api";

const TYPES = [
  { key: "anlagenbereich", label: "Anlagenbereiche" },
  { key: "mangel", label: "Standard-Mängel" },
  { key: "sanierung", label: "Sanierungsmaßnahmen" },
  { key: "messparameter", label: "Messparameter" },
];

export default function HpsKataloge() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const all = await Promise.all(
          TYPES.map((t) =>
            authFetch(`${API}/hps/catalogs/${t.key}`)
              .then(r => r.json()).then((items) => [t.key, items])
          )
        );
        setData(Object.fromEntries(all));
      } finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="text-white/60 text-sm py-20 text-center">Lade Kataloge …</div>;

  return (
    <div className="space-y-6" data-testid="hps-kataloge">
      <div>
        <h1 className="text-2xl font-semibold text-white">Kataloge</h1>
        <p className="text-sm text-white/55 mt-1">Vorlagen für Anlagenbereiche, Mängel, Sanierungsmaßnahmen und Messparameter.</p>
      </div>

      {TYPES.map((t) => (
        <section key={t.key} className="rounded-xl border border-white/10 p-5"
                 style={{ background: "rgba(255,255,255,0.04)" }}>
          <h2 className="text-sm font-semibold text-white mb-3 uppercase tracking-wider flex items-center gap-2">
            <BookOpen className="w-4 h-4 text-blue-300" /> {t.label}
          </h2>
          <div className="space-y-1.5">
            {(data[t.key] || []).map((item) => (
              <div key={item.id} className="rounded-md border border-white/5 px-3 py-2 text-sm flex items-center justify-between gap-3"
                   style={{ background: "rgba(255,255,255,0.02)" }}
                   data-testid={`hps-catalog-${t.key}-${item.key}`}>
                <div className="min-w-0">
                  <div className="text-white">{item.label}</div>
                  {item.description && <div className="text-xs text-white/45 mt-0.5">{item.description}</div>}
                </div>
                {item.priority && (
                  <span className="text-[10px] uppercase tracking-wider rounded px-1.5 py-0.5 bg-white/5 text-white/60 border border-white/10 shrink-0">{item.priority}</span>
                )}
                {item.unit && (
                  <span className="text-[10px] tracking-wider rounded px-1.5 py-0.5 bg-blue-500/15 text-blue-200 border border-blue-400/30 shrink-0">{item.unit}</span>
                )}
              </div>
            ))}
            {!data[t.key]?.length && <div className="text-sm text-white/40 italic">Noch keine Einträge.</div>}
          </div>
        </section>
      ))}
    </div>
  );
}
